// test2789
(2789 && 0);
